export const onboarding = {
  intro: {
    /** 見出し。emphasis の語を強調表示する */
    heading: [
      { text: "今夜、" },
      { text: "ビデオ通話", emphasis: true },
      { text: "で\n好みの" },
      { text: "おかず", emphasis: true },
      { text: "を見つけよう" },
    ] as { text: string; emphasis?: boolean }[],
    badges: ["匿名OK", "本人確認なし", "無料登録"],
    start: "無料ではじめる",
  },
  welcome: {
    heading: (args: { appName: string }) => `${args.appName}へようこそ`,
    /** emphasis の語を強調表示する */
    featuresTitle: (args: { appName: string }) =>
      [
        { text: `${args.appName}ではこんな` },
        { text: "体験", emphasis: true },
        { text: "できるよ" },
      ] as { text: string; emphasis?: boolean }[],
    /** WelcomeScreen の FEATURE_VISUALS と同じ並び。description の vibrate の語は定期的に震わせる */
    features: [
      {
        title: "ビデオ通話",
        description: [{ text: "女の子と見せ合い通話を楽しめるよ" }],
      },
      {
        title: "チャット",
        description: [{ text: "メッセージ・画像・動画交換もできるよ" }],
      },
      {
        title: "ライブ配信閲覧",
        description: [
          { text: "遠隔バイブ", vibrate: true },
          { text: "・コメントで盛り上がろう" },
        ],
      },
    ] as {
      title: string;
      description: { text: string; vibrate?: boolean }[];
    }[],
    liveBadge: "LIVE",
    /** ビデオ通話のアイコンから浮かび上がる文字 */
    videoFloatingLetter: "H",
    next: "次へ",
  },
  /** ようこその次に、何をしたいか（志向）を聞く画面 */
  intent: {
    heading: "まずは女の子となにしてみたい？",
    /** IntentScreen の INTENT_OPTIONS と同じ並び */
    options: ["ビデオ通話がしたい", "チャットがしたい", "ライブ配信が見たい"],
  },
  /** 志向の次、登録フォームの前に新規登録を促す中継画面 */
  signupNudge: {
    /** 志向を全部選んだときだけ出す */
    greedy: "欲張りだね！",
    /** 志向を1〜2個選んだとき。labels は intentLabels を選択肢の並びで渡す */
    picked: (args: { labels: string[] }) => `${args.labels.join("と")}だね！`,
    intentLabels: { call: "ビデオ通話", chat: "チャット", live: "ライブ配信" },
    message: "さっそくプロフィールを作って\n女の子と話してみよう！",
    badges: ["電話番号・メールアドレス不要！", "匿名OK！"],
    cta: "プロフィール登録に進む",
  },
  /** 登録直後に出す完了画面。登録前に志向を選んだ人だけ */
  registerComplete: {
    title: "プロフィール登録完了！",
    question: "どっちに行くか選べるよ",
    experienceTitle: "今すぐはじめる",
    matchTitle: "好みを診断する",
    /** 「好みを診断する」の真上に出す吹き出し */
    matchAppeal: "好みの女の子が\n選べるようになるよ",
    /** 吹き出しの上の縁に載せる札 */
    matchAppealLabel: "診断した人限定",
  },
  /** オンボーディングの最後に出す、ATT 許可ダイアログ前の説明 */
  attPrePrompt: {
    heading: "好みの子ともっと繋がるために",
    /** 本文1行目。emphasis はブランド色で大きくし、拡大・縮小させる */
    bodyLine1: {
      before: "次の画面で",
      emphasis: "許可",
      after: "すると、アプリを使うほど",
    },
    bodyLine2: "好みの子の精度が良くなるよ",
    next: "次へ",
    later: "今はしない",
  },
  progress: {
    /** 段の名前。OnboardingProgress の current と同じ並び */
    steps: ["好みを選ぶ", "気になる子を選ぶ", "いいね完了"],
    /** 段の名前の前に付ける番号（STEP①〜） */
    stepNumber: (args: { current: number }) =>
      `STEP${"①②③④⑤⑥⑦⑧⑨"[args.current - 1] ?? args.current}`,
    counter: (args: { current: number; total: number }) =>
      `${args.current} / ${args.total}`,
  },
  bridge: {
    message: "まずはあなたの\n好みと過ごし方を\n教えて",
    hint: "タップで次へ（3秒後に自動で進みます）",
  },
  preferences: {
    questions: {
      stepToCall: "女の子とはどう始めたい？",
      showingFace: "顔は見たい？",
      silentOk: "通話中はどう過ごしたい？",
      chatStyle: "どんな会話がしたい？",
      bustSize: "好きな胸の大きさは？",
      bodyType: "好きな体型は？",
      age: "好きな年代は？",
      personality: "好きな性格は？",
      animalFace: "好きな顔のタイプは？",
    },
    next: "次へ",
    /** coco+ の見出しの上に出す設問番号 */
    questionNumber: (args: { current: number; total: number }) =>
      `質問 ${args.current} / ${args.total}`,
    /** coco+ の複数選択の設問で「次へ」の上に出す */
    selectedCount: (args: { count: number }) => `${args.count}つ選択中`,
    selectAtLeastOne: "1つ以上選んでね",
    multipleHint: "複数選べます",
    back: "前の質問に戻る",
    rows: {
      stepToCall: {
        left: "すぐ通話",
        mid: "少し話してから",
        right: "チャット中心",
      },
      showingFace: { left: "顔が見たい", mid: "どっちも", right: "気にしない" },
      silentOk: {
        left: "無言がいい",
        mid: "どっちも",
        right: "ちゃんと話したい",
      },
      chatStyle: { left: "雑談したい", mid: "疑似恋愛", right: "即エロ希望" },
      bustSize: { left: "貧乳", mid: "普通", right: "巨乳" },
      age: { left: "JD", mid: "若め", right: "熟女" },
      personality: { left: "Sっぽい", mid: "どっちも", right: "Mっぽい" },
    },
    /** 体型。並びは選択肢の番号どおり（1=スレンダー 〜 6=長身） */
    bodyType: ["スレンダー", "普通", "ぽっちゃり", "グラマー", "小柄", "長身"],
    /** 顔の系統。並びは選択肢の番号どおり（1=たぬき 〜 6=うさぎ）。A/Bの処置群だけに出す */
    animalFace: ["たぬき顔", "きつね顔", "ヘビ顔", "犬顔", "猫顔", "うさぎ顔"],
    submit: "好みに合う子を探す",
  },
  /** 既存オンボーディング（5問）の文言。A/Bの対照群に出すためだけに残してある */
  preferencesLegacy: {
    heading: "好みのタイプと\n興奮するタイプは？",
    hint: "未選択の項目は「どっちも」のままでOK",
    both: "どっちも",
    rows: {
      bustSize: { left: "貧乳", mid: "普通", right: "巨乳" },
      personality: { left: "Sっぽい", right: "Mっぽい" },
      age: { left: "J○", right: "熟女" },
      marriage: { left: "未婚", right: "人妻" },
      style: { left: "ギャル", right: "清楚" },
    },
    submit: "好みの女の子情報を送信",
  },
  analyzing: {
    title: "あなたの好みを解析中",
    subtitle: "好みのデータとマッチング中…",
  },
  results: {
    heading: "あなたの好みに合いそうな女の子",
    hint: "気になる子にチェックを付けていいねしてみませんか？",
    sendLabel: (args: { count: number }) => `♥ ${args.count}人にいいねを送る`,
    selectPrompt: "気になる子を選んでね",
    /** 候補が0件のとき。ここで出口を塞ぐと先に進めなくなる */
    emptyHeading: "条件に合う子が見つかりませんでした",
    emptyHint: "条件を気にせず、いま話せる子を見てみませんか？",
    emptyCta: "女の子を見にいく",
  },
  swipe: {
    heading: "気になる子に無料でいいねしよう",
    free: "無料",
    hint: "右にスワイプでいいね、左でパス",
    like: "いいね",
    pass: "パス",
    remaining: (args: { count: number }) => `あと${args.count}人`,
    /** 見出し横の短縮表示。読み上げには sendNowLabel を使う */
    sendNow: (args: { count: number }) => `${args.count}人に無料で送る`,
    sendNowLabel: (args: { count: number }) =>
      `${args.count}人に無料でいいねを送る`,
    openProfile: (args: { name: string }) => `${args.name}のプロフィールを見る`,
    matched: (args: { labels: string }) => `好みと一致：${args.labels}`,
    /** search_users_by_preference の matched_axes 表示名 */
    matchedAxes: {
      chat_styles: "会話",
      bust_sizes: "胸の大きさ",
      body_types: "体型",
      age_ranges: "年代",
      personalities: "性格",
      animal_faces: "顔のタイプ",
    },
    /** coco+ の上部に出す残り人数と補足 */
    remainingShort: (args: { count: number }) => `残り${args.count}人`,
    progressLabel: (args: { current: number; total: number }) =>
      `${args.total}人中${args.current}人目`,
    picked: (args: { count: number }) =>
      `あなたの好みに合いそうな${args.count}人を選びました`,
    likeFree: "いいね（無料）",
    close: "閉じる",
    endHeading: "気になる子はいなかった？",
    endHint: "もう一度見るか、いま話せる子を探しにいきましょう",
    restart: "もう一度見る",
  },
  likeSent: {
    label: (args: { count: number }) => `${args.count}人にいいねを送りました！`,
  },
  /** coco+ のポイント表示（オンボーディング上部） */
  point: {
    value: (args: { point: string }) => `${args.point}pt`,
    label: (args: { point: string }) => `保有ポイント${args.point}pt`,
  },
  /** coco+ のいいね送信後の画面。bubbles の代わりに出す */
  likeResult: {
    heading: (args: { count: number }) => `${args.count}人にいいねを送りました`,
    hint: "返信が来たらメッセージでお知らせします",
    nameAge: (args: { name: string; age: number }) =>
      `${args.name} ${args.age}`,
    openProfile: (args: { name: string }) => `${args.name}のプロフィールを見る`,
    howToTitle: "おすすめの楽しみ方",
    /** 番号付きの手順。emphasis の語を太字にする */
    steps: [
      [{ text: "まずはメッセージ", emphasis: true }, { text: "で話してみる" }],
      [
        { text: "気が合ったら" },
        { text: "ビデオ通話", emphasis: true },
        { text: "へ" },
      ],
    ] as { text: string; emphasis?: boolean }[][],
    /** 2行目を「メッセージ〜」から始める */
    bonus: (args: { point: number; messages: number; videoMinutes: number }) =>
      `プレゼントの${args.point}ptで、\nメッセージ${args.messages}通 または ビデオ約${args.videoMinutes}分 無料`,
    startCta: "今すぐ始める",
  },
  /** Sakura のチャット風オンボーディングだけで使う文言 */
  sakuraChat: {
    intro: {
      message: (args: { appName: string }) =>
        `${args.appName}は全国の女の子と話せるアプリです。`,
      subMessage: "好みの女の子を見つけるお手伝いさせてください。",
      hint: "タップして会話をはじめる",
      start: "好みを見つける",
    },
    singleHint: "ひとつ選んでね",
    send: "これで送信",
    /** 返信の吹き出しで複数の回答をつなぐ */
    answerSeparator: "・",
  },
  bubbles: {
    heading: "いいねを送った女の子たち",
    hint: "アイコンをタップするとプロフィールが見れます",
    cta: "女の子と話にいこう",
  },
} as const;
